
import React from 'react'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';


function CustomMenu({open, genres,genresName, handleOpen, handleClose, handleChange, handleGenre}) {
    
  return (
    <FormControl 
    sx={{m: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}  
    >

            <InputLabel 
              
              disableAnimation= 'true'     
              sx={{   
                '&.MuiOutlinedInput-notchedOutline': { display: 'none'},
                '&.MuiInputLabel-shrink': {display: 'none'},
                
                position: 'absolute',     
                left: 10,
                top: -13,
                fontFamily: 'Staatliches',
                color: '#ffff',
                fontSize: '1em',
                }}
                >
                Genre
                </InputLabel>
            <Select
       
              sx={{ 
                
                '.MuiOutlinedInput-notchedOutline': { display: 'none'},
                width: '100px',
                height: '30px',
                backgroundColor: '#e53b3b',
                border: '2px solid #e53b3b',
                borderRadius: '10px',
                fontFamily: 'Staatliches',
                color: '#ffff',
                display: 'flex',
                alignItems: 'center',
                alignContent: 'center',
                justifyContent:'center'
  
              }} 
              labelId="demo-controlled-open-select-label"
              id="demo-controlled-open-select"
              open={open}
              onClose={handleClose}
              onOpen={handleOpen}
              value={genres}
              label="Genre"
              onChange={handleChange}
            >
              <MenuItem  
              sx={{
                fontFamily: 'Staatliches',
                color: '#e53b3b'
              }}
          
              value=' '>
                <em> Aléatoire </em>
              </MenuItem>
              {genresName.map((genre) => 
              <MenuItem 
                sx={{ 
                  fontFamily: 'Staatliches', 
                  color: '#e53b3b'
                }} 
                value={genre.id} 
                onClick={() => handleGenre(genre.id)}
                > {genre.name} 
                </MenuItem> 
                )}
              
            </Select>
    </FormControl>
  )
}

export default CustomMenu











 